import { styled } from 'Theme'

export const StyledListTitle = styled.span`
  color: ${({ theme }): string => theme.colors.primary};
  display: block;
  font-size: ${({ theme }): string => theme.list.item.title.fontSize};
  font-weight: ${({ theme }): string => theme.list.item.title.fontWeight};
  line-height: 24px;
`
